import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.aside`
  display: flex;
  align-items: center;

  & > label {
    color: ${ColorPalette.HEX.DimGray};
  }
`;

export const ToolTip = styled.img`
  margin-left: 3px;
  vertical-align: middle;
`;

export const SimpleTooltipContainer = styled.div`
  margin-top: 10px;
  margin-left: 2px;
`;
